// src/api/myItProcessApi.js
// myITprocess API client — reads from backend blob cache, manages mappings.

import apiClient from "./apiClient";

export async function getMyItProcessStatus() {
  const r = await apiClient.get("/api/myitprocess/status");
  return r.data;
}

export async function triggerMyItProcessSync() {
  const r = await apiClient.post("/api/myitprocess/sync", {});
  return r.data;
}

// Composite blob — used at app startup to hydrate the myITprocess slice.
export async function getMyItProcessData() {
  const r = await apiClient.get("/api/myitprocess/data");
  return r.data;
}

// Per-resource fetches (optional clientId filter for everything except /clients & /summaries).
export async function getMyItProcessSummaries() {
  const r = await apiClient.get("/api/myitprocess/summaries");
  return r.data;
}

export async function getMyItProcessClients() {
  const r = await apiClient.get("/api/myitprocess/clients");
  return r.data;
}

export async function getMyItProcessReviews(clientId) {
  const r = await apiClient.get("/api/myitprocess/reviews", { params: clientId ? { clientId } : {} });
  return r.data;
}

export async function getMyItProcessOverdue(clientId) {
  const r = await apiClient.get("/api/myitprocess/overdue", { params: clientId ? { clientId } : {} });
  return r.data;
}

export async function getMyItProcessFindings(clientId) {
  const r = await apiClient.get("/api/myitprocess/findings", { params: clientId ? { clientId } : {} });
  return r.data;
}

export async function getMyItProcessRecommendations(clientId) {
  const r = await apiClient.get("/api/myitprocess/recommendations", { params: clientId ? { clientId } : {} });
  return r.data;
}

export async function getMyItProcessInitiatives(clientId) {
  const r = await apiClient.get("/api/myitprocess/initiatives", { params: clientId ? { clientId } : {} });
  return r.data;
}

export async function getMyItProcessMeetings(clientId) {
  const r = await apiClient.get("/api/myitprocess/meetings", { params: clientId ? { clientId } : {} });
  return r.data;
}

// ── Mapping overrides ──────────────────────────────────────────────────────────

export async function getMyItProcessMappings() {
  const r = await apiClient.get("/api/myitprocess/mappings");
  return r.data;
}

// Set or clear a manual Autotask ↔ myITprocess client mapping.
//
//   setMyItProcessMapping(mitpClientId, autotaskCompanyId)  → manual link
//   setMyItProcessMapping(mitpClientId, "")                  → explicitly "no match"
//   setMyItProcessMapping(mitpClientId, null)                → clear, revert to auto
export async function setMyItProcessMapping(myItProcessClientId, autotaskCompanyId) {
  const r = await apiClient.post("/api/myitprocess/mappings", {
    myItProcessClientId,
    autotaskCompanyId,
  });
  return r.data;
}
